import * as Fetch from '../data/Fetch';

const setAllStudySitesType = 'SET_ALL_STUDY_SITES';
const setStudySiteType = 'SET_STUDY_SITE';
const setStudySitesFetchingType = 'SET_STUDY_SITES_FETCHING';

const initialState = {
    all: null,
    fetching: false,
    studySite: null
};

export const actionCreators = {
    get: (id) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studySitesState = getState().studySites;
        if (badState(accountsState, studySitesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`StudySites/GetById?id=${id}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setStudySiteType);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studySitesState = getState().studySites;
        if (badState(accountsState, studySitesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("StudySites/GetAll");
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllStudySitesType);
    },

    getAllBySite: (siteId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studySitesState = getState().studySites;
        if (badState(accountsState, studySitesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`StudySites/GetAllBySiteId?siteId=${siteId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllStudySitesType);
    },

    set: (data) => async (dispatch) => {
        dispatch({ type: setStudySiteType, data });
    }
};

function badState(accountsState, studySitesState, checkStudySite, dispatch) {
    if (accountsState == null ||
        studySitesState == null ||
        studySitesState.fetching) {
        return true;
    }
    if (checkStudySite &&
        studySitesState.studySite == null) {
        return true;
    }

    setFetching(true, dispatch);
    return false;
}

function setFetching(data, dispatch) {
    dispatch({ type: setStudySitesFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setStudySitesFetchingType);
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setAllStudySitesType) {
        return {
            ...state,
            all: action.data
        };
    }

    if (action.type === setStudySiteType) {
        return {
            ...state,
            studySite: action.data
        };
    }

    if (action.type === setStudySitesFetchingType) {
        return {
            ...state,
            fetching: action.data
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/StudySites.js